export default __webpack_public_path__ + "static/media/logo.3a4f3b58.svg";